<script>
    import { _ } from "svelte-i18n";
    import { assets, uploadAsset, fetchAssets } from "../../stores/assets";
    import Card from "./Card.svelte";
    import { Link } from "svelte-routing";
    import Icon from "fa-svelte";
    import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
    import { handleAsync } from "../../common/safe_promise";

    export let filter;

    $: filteredAssets = $assets && $assets.filter((it) => true);

    const handleFileUpload = () => {
        file.click();
    };

    const handleFileChosen = handleAsync(async (event) => {
        if (!event.target.value) return;
        const files = Array.from(event.target.files);
        await Promise.all(files.map((it) => uploadAsset(it)));
        await fetchAssets();
        event.target.value = "";
    });

    let file;
</script>

<style>
    .grid {
        grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    }
</style>

<input
    type="file"
    class="hidden"
    bind:this={file}
    accept={filter}
    on:change={handleFileChosen} />

<div class="p-4 flex flex-col">
    {#if filteredAssets}
        <div class="mb-4 self-end">
            <button
                class="flex items-center space-x-2"
                on:click={handleFileUpload}>
                <span>{$_('Upload')}</span>
                <Icon icon={faCloudUploadAlt} />
            </button>
        </div>
    {/if}
    {#if filteredAssets && filteredAssets.length}
        <div class="p-4 grid gap-8 justify-center">
            {#each $assets as asset}
                <slot {asset}>
                    <Card {asset} />
                </slot>
            {/each}
        </div>
    {:else}
        <div class="flex flex-col items-center">
            <h1>{$_('NothingHereYet')}</h1>
            <p class="text-6xl">🤷</p>
        </div>
    {/if}
</div>
